import { request } from "../../utils/request";

export const postLoginApi = (body: Login.PostLoginPayloadType) => {
  // 使用JSON格式传递登录参数
  const requestBody = {
    username: body.username,
    password: body.password,
    // 将前端「记住我」勾选状态透传给后端，未勾选时默认为 false
    rememberMe: body.rememberMe ?? false,
  };

  return request<Login.LoginResponse>("/system/auth/login", {
    method: "POST",
    body: requestBody,
    skipAuth: true, // 登录请求不需要认证头
  });
};

export const postRegisterApi = (body: Login.PostRegisterPayloadType) => {
  // 注册接口参数：username, mobile, password, code
  const requestBody = {
    username: body.username,
    mobile: body.phone || body.mobile, // 兼容 phone 和 mobile 字段
    password: body.password,
    // 注册场景 scene=5 对应后端 MEMBER_REGISTER
    // 如果前端传入了 code 字段则一并提交，否则不传（后端字段可选）
    ...(body.code ? { code: body.code } : {}),
  };

  return request<Login.RegisterResponse>("/system/user/register", {
    method: "POST",
    body: requestBody,
    skipAuth: true,
  });
};

/**
 * 发送短信验证码
 * @param body.mobile 手机号
 * @param body.scene 业务场景（与后端 SmsSceneEnum 对齐）
 *   - 1 MEMBER_LOGIN（用户登录）
 *   - 4 MEMBER_RESET_PASSWORD（忘记密码）
 *   - 5 MEMBER_REGISTER（注册）
 *   - 21 ADMIN_MEMBER_LOGIN（后台用户登录）
 */
export const sendSmsCodeApi = (body: Login.PostSmsCodePayloadType) => {
  return request<Login.SmsCodeResponse>("/system/auth/send-sms-code", {
    method: "POST",
    body: body,
    skipAuth: true, // 发送短信不需要登录
  });
};

/**
 * 短信验证码登录
 */
export const smsLoginApi = (body: Login.PostSmsLoginPayloadType) => {
  return request<Login.LoginResponse>("/system/auth/sms-login", {
    method: "POST",
    body: body,
    skipAuth: true,
  });
};

/**
 * 忘记密码 - 短信校验通过后重置密码
 */
export const resetPasswordApi = (body: Login.PostResetPasswordPayloadType) => {
  return request<Login.ResetPasswordResponse>("/system/auth/reset-password", {
    method: "POST",
    body: body,
    skipAuth: true,
  });
};
